import NotVerifiedProject from '@/models/common/not-verified-project.js'
import { numsToRMBSymbolAndMillimeter } from "common/js/util";
export default {
  data() {
    return {
      // 未核实项目
      notVerifiedProjectList: []
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 未核实项目
     */
    initNotVerifiedProject(data) {
      NotVerifiedProject.getNotVerifiedProjectList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.createTime = i.date;
            obj.count = i.count;
            obj.projectList = []
            i.projectList.map(i => {
              let obj2 = {}
              obj2.id = i.id
              obj2.name = i.projectName
              obj2.collect = numsToRMBSymbolAndMillimeter(i.totalTaxIncludedAmount)
              obj2.branch = numsToRMBSymbolAndMillimeter(i.totalCost)
              obj.projectList.push(obj2)
            })
            arr.push(obj);
          });
          this.notVerifiedProjectList = arr;
        } else {
          this.$message.error(res.message);
        }
      })
    },
  }
}